import React from "react";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { ReactTyped } from "react-typed";
import avatar from "../avatar.png";

const Header = () => {
    return (
        <Box
            sx={{
                height: "100vh",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                zIndex: 1,
                position: "relative",
            }}
        >
            <Typography
                component="h1"
                sx={{
                    position: "absolute",
                    width: 1,
                    height: 1,
                    padding: 0,
                    margin: -1,
                    overflow: "hidden",
                    clip: "rect(0, 0, 0, 0)",
                    whiteSpace: "nowrap",
                    border: 0,
                }}
            >
                Igor Sonntag
            </Typography>
            <Grid container justifyContent="center">
                <Avatar
                    sx={{
                        width: (theme) => theme.spacing(15),
                        height: (theme) => theme.spacing(15),
                        margin: (theme) => theme.spacing(1),
                    }}
                    src={avatar}
                    alt="Igor Sonntag"
                />
            </Grid>
            <Typography sx={{ color: "tomato" }} variant="h4">
                <ReactTyped strings={["Igor Sonntag"]} typeSpeed={40}/>
            </Typography>

            <Typography sx={{ color: "tan", textTransform: "uppercase" }} variant="h5">
                <ReactTyped
                    strings={[
                        "Senior Platform Developer",
                        "Strategic problem-solving",
                        "Decision-making under constraints",
                        "Ownership mindset",
                        "Leadership, mentoring & coaching",
                        "Adaptivity and openness",
                        "Ability to simplify complexity",
                        "Receptiveness to feedback",
                        "Collaborative low-ego attitude"
                    ]}
                    typeSpeed={40}
                    backSpeed={50}
                    loop
                />
            </Typography>
        </Box>
    );
};

export default Header;
